import { Injectable, NgZone } from "@angular/core";
import { Socket } from "ngx-socket-io";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class CommonServices {
  on(arg0: string) {
    throw new Error("Method not implemented.");
  }
  constructor(private socket: Socket, private zone: NgZone) {}

  publishMessage(type: string, tripdetails: any) {
    this.socket.emit(type, tripdetails);
  }

  // getPublishedEvent(channelName: string) {
  //   console.log("Listening on channelName:", channelName);
  //   return this.socket.fromEvent(channelName).pipe(
  //     map((data: any) => {
  //       console.log("Received data:", data); // Log for debugging
  //       return data;
  //     })
  //   );
  // }
  getPublishedEvent(channelName: string) {
    return new Observable((subscriber) => {
      this.socket.on(channelName, (data: any) => {
        this.zone.run(() => {
          console.log("Received socket data in zone:", data);
          subscriber.next(data);
        });
      });
    });
  }
}
